import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createFilter: {
		id: 'create-filter-button.create-filter',
		defaultMessage: 'Create filter',
		description: 'Text on the button to create a new filter.',
	},
});
